import { useState } from "react";
import { CalendarDays } from "lucide-react";
import { ApiService, MY_REPORT } from "../../../../services/api";
import { StudentReportType } from "../../../../types/student-report";
import checkPermission, { checkSuperAdmin } from "../../../../utils/permission";
import { PlanTab } from "../../../coach-observe/CoachObserve";
import StudentReportDisplay from "./StudentReportDisplay";
import MyVideoProgress from "./MyVideoProgress";

// Raporlarım — öğrencinin kendi raporu. Öğretmenin "Öğrenci Raporları"nda ve velinin ekranında gördüğü raporun
// aynısı (StudentReportDisplay); veri /report/me/* uçlarından gelir. Kabuk ve sekmeler ReportsView ile aynı.
// Koçum Planım: öğretmenin Koç Gözlem'de gördüğü plan görünümü (PlanTab), salt-okur /report/me/coach-plan ile.
type MyTab = StudentReportType | "coach" | "videos";

const loadMyPlan = (range?: { from: string; to: string }) => ApiService.getMyCoachPlan(range);

export default function MyReportsView() {
  const [tab, setTab] = useState<MyTab>("all");
  const hasCoach = checkSuperAdmin() || checkPermission("navigator_view");
  const tabs: Array<[MyTab, string]> = [
    ["all", "Tümü"],
    ["homework", "Ödevler"],
    ["independent", "Testler"],
    ...(hasCoach ? [["coach", "Koçum Planım"] as [MyTab, string]] : []),
    ["videos", "Videolar"],
  ];

  return (
    <div className="h-full bg-gray-50 flex flex-col">
      <div className="flex-1 min-h-0 px-3 sm:px-4">
        <div className="h-full bg-gray-50 relative rounded-lg shadow-sm flex flex-col mr-1">
          <div className="px-6 py-6 w-full flex-1 flex flex-col min-h-0">
            <div className="mb-4 sm:mb-6 border-b border-gray-200">
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-gray-900">Raporlarım</span>
                </div>
                <div className="flex items-center gap-4 sm:gap-6 text-sm text-gray-600 overflow-x-auto scrollbar-hide w-full sm:w-auto -mx-2 px-2 whitespace-nowrap">
                  {tabs.map(([value, label]) => (
                    <button
                      key={value}
                      onClick={() => setTab(value)}
                      className={`pb-3 transition-all duration-200 flex-shrink-0 ${tab === value ? "text-blue-600 font-medium border-b-2 border-blue-500" : "hover:text-gray-900"
                        }`}>
                      {label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div className="flex-1 min-h-0 overflow-y-auto">
              {tab === "coach" ? (
                <div className="w-full pb-4 sm:pb-6 px-2 sm:px-4 lg:px-0">
                  <div className="bg-white rounded-lg border border-gray-200 p-3 sm:p-4">
                    <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4 flex items-center">
                      <CalendarDays className="w-4 h-4 sm:w-5 sm:h-5 mr-2" />
                      Koçum Planım
                    </h3>
                    <PlanTab userId={MY_REPORT} loader={loadMyPlan} emptyText="Koçum'da henüz aktif bir planın yok. Koçum'a girip tanışmayı tamamladığında planın burada görünür." />
                  </div>
                </div>
              ) : tab === "videos" ? (
                <MyVideoProgress />
              ) : (
                <StudentReportDisplay userId={MY_REPORT} reportType={tab} selectedMainLessonFilter={null} selectedTopicFilter={null} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
